import React, { Component } from 'react'
import butter from '../../elements/butterClient/butterClient.js'
import { Helmet } from 'react-helmet'
import { apiProcess } from "components/api/api"
import { MAP_SIZES_TO_PROPS } from '../../../constants/utils/mapSizesToProps.js'
import withSizes from 'react-sizes'
import { compose } from 'recompose'
import { withRouter } from 'react-router-dom'
import moment from 'moment'
import { trackSearchFromHeader } from '../../elements/tracking/searchTracking.js'
import BlogMenu from '../menu/blogMenu.js'
import AuthorBlock from '../authorBlock/authorBlock.js'
import fitvids from 'fitvids'
import { blogPostEndpoints } from 'constants/blogs/blogs.js'
import { Header, Columns, Container, Dropdown } from '../../elements'
import RelatedPosts from '../relatedPosts/relatedPosts.js'
import MetaTags from '../../elements/meta/metaTags.js'
import { userPhotoURL } from '../../../constants/images/sizesAndQuality'
import BlogSocialShare from '../socialShare/socialShare'
import cloudinary from 'cloudinary-core'
import { CLOUDINARY_NAME } from '../../../constants/images/cloudinary'
import { trackPageView } from '../../elements/tracking/pagesAndMarketingTracking.js'
import ListingRentCTA from 'components/marketing/listRentCTA/listRentCTA.js'
import { MAPBOX_API_KEY } from 'constants/index.js'
import BlogAdvertisement from '../advertisement/blogAdv.js'
import 'components/theme/mapboxSearchAutoComplete/mapboxSearchAutoComplete.css'
import 'components/theme/mapboxSearchAutoComplete/index.css'

const cl = new cloudinary.Cloudinary({
  cloud_name: CLOUDINARY_NAME,
})

const cleanArticleBody = (html) => {
  const doc = new DOMParser().parseFromString(html, "text/html");

  return doc.documentElement.textContent
    .replace(/\u00A0/g, " ")        // Replace non-breaking spaces
    .replace(/\s+/g, " ")           // Collapse multiple spaces
    .replace(/\s+([.,!?;:])/g, "$1") // Remove spaces before punctuation
    .trim();
}

function handleSuggestionSelect(
  location, lat, lng, props
) {
  let url =
    '/search?location=' +
    location +
    '&latitude=' +
    lat +
    '&longitude=' +
    lng

    url += '&min_distance=0&max_distance=75'

  const trackSearch = {
    search_location: location,
    search_latitude: lat,
    search_longitude: lng,
  }

  trackSearchFromHeader(trackSearch)
  props.history.push(url)
}

function renderDropDownResults(results, spanElement, props) {
  const dropdownWrapper = document.createElement('div');
  dropdownWrapper.id = 'dropdown-wrapper';

  if (results.length > 0) {
    const reactMapboxMenu = document.createElement('div');
    reactMapboxMenu.className = 'react-mapbox-ac-menu';
    reactMapboxMenu.style.display = 'block';

    results.forEach((place, i) => {
      const placeName = place.place_name;
      const placeArray = placeName?.split(',');
      const region = place.context.find(context => context.id.includes('region'));
      const city = place.context.find(context => context.id.includes('place'));
      const shortCode = region ? region.short_code?.split('-') : null;
      const shortCodeAbbr = shortCode?.reverse()?.map(code => code)?.join(', ');
      const dataSuggestion = placeArray[0] + (city ? '' + city.text : '') + ' ' + shortCodeAbbr;

      const suggestionDiv = document.createElement('div');
      suggestionDiv.className = 'react-mapbox-ac-suggestion';
      suggestionDiv.id = 'mapbox-ac-suggestion-wrapper';
      suggestionDiv.onclick = (e) => handleSuggestionSelect(
        dataSuggestion, place.center[1], place.center[0], props
      );
      suggestionDiv.setAttribute('data-suggestion', dataSuggestion);
      suggestionDiv.setAttribute('data-lng', place.center[0]);
      suggestionDiv.setAttribute('data-lat', place.center[1]);
      suggestionDiv.setAttribute('data-text', place.text);
      suggestionDiv.setAttribute('data-placename', placeName);

      const placeFirstName = document.createElement('div');
      placeFirstName.className = 'place-firstName';
      placeFirstName.setAttribute('data-suggestion', dataSuggestion);
      placeFirstName.setAttribute('data-lng', place.center[0]);
      placeFirstName.setAttribute('data-lat', place.center[1]);
      placeFirstName.setAttribute('data-text', place.text);
      placeFirstName.setAttribute('data-placename', placeName);
      placeFirstName.textContent = placeArray.slice(0, 2).join(', ');

      suggestionDiv.appendChild(placeFirstName);

      if (placeArray?.length > 1) {
        const span = document.createElement('span');
        span.setAttribute('data-suggestion', dataSuggestion);
        span.setAttribute('data-lng', place.center[0]);
        span.setAttribute('data-lat', place.center[1]);
        span.setAttribute('data-placename', placeName);
        span.innerHTML = shortCodeAbbr ? "&nbsp;" + shortCodeAbbr : placeArray?.slice(1)?.join(', ');

        suggestionDiv.appendChild(span);
      }

      reactMapboxMenu.appendChild(suggestionDiv);
    });

    dropdownWrapper.appendChild(reactMapboxMenu);
  }

  spanElement.appendChild(dropdownWrapper);
}

class SinglePost extends Component {
  constructor(props) {
    super(props)
    this.updateQuery = this.updateQuery.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.integrateDropDownElement = this.integrateDropDownElement.bind(this)
  }
  state = {
    bikeSearchInputId: 'blog-post-bike-search-input', 
    blogPostSearchBtnId: 'blog-post-search-btn',
    searchUrl: null,
    trackSearchData: {},
    data: {},
    relatedPosts: false,
    loading: true,
    error: false,
    errorMsg: '',
    query: '',
    queryResults: [],
    publicKey: this.props.publicKey,
    resetSearch: this.props.resetSearch ? this.props.resetSearch : false,
    desktopAdvertisement: null,
    mobileAdvertisement: null
  }

  componentDidMount() {
    this.getBlogAdvertisement()
    let post = this.props.match.params.post
    if (
      post == '15-must-attend-moto-shows-in-2023-everything-you-need-to-know' ||
      post == '15-must-attend-moto-shows-in-2022-everything-you-need-to-know'
      ) {
        this.loadPost('15-must-attend-moto-shows-this-year-everything-you-need-to-know')
        this.props.history.push('15-must-attend-moto-shows-this-year-everything-you-need-to-know')
    } else {
      this.loadPost()
    }
    document.body.classList.add('blog')
  }

  updateQuery(locationName) {
    this.setState({ query: locationName });
    const header = { 'Content-Type': 'application/json' };
    let typesQP = ['address', 'postcode', 'place'].join(',')

    let path = 'https://api.mapbox.com/geocoding/v5/mapbox.places/' + this.state.query + '.json?&types=' + typesQP + '&access_token=' + MAPBOX_API_KEY;
    if (this.props.country) {
      path = 'https://api.mapbox.com/geocoding/v5/mapbox.places/' + this.state.query + '.json?&types=' + typesQP + '&access_token=' + MAPBOX_API_KEY + '&country=' + this.props.country;
    }

    if (this.state.query?.length >= 2) {
      return fetch(path, {
        headers: header,
      }).then(res => {
        if (!res.ok) throw Error(res.statusText)
        return res.json();
      }).then(json => {
        this.setState({
          error: false,
          queryResults: json.features
        })
        this.integrateDropDownElement(json.features)
      }).catch(err => {
        this.setState({
          error: true,
          errorMsg: 'There was a problem retrieving data from mapbox',
          queryResults: []
        });
      })
    } else {
      this.setState({
        error: false,
        queryResults: []
      });
    }
  }

  uploadSearchScript = () => {
    const searchInputElement = document.getElementById(this.state.bikeSearchInputId);
    const blogPostSearchBtn = document.getElementById(this.state.blogPostSearchBtnId)
    const blogPostGlobeIcon = document.getElementById('blog-post-globe-icon-wrapper')
    
    if (searchInputElement && this.props.isMobile) {
      searchInputElement.placeholder = "Moto rentals! (search by City)"
    }

    if (searchInputElement) {
      searchInputElement.addEventListener('input', this.handleInputChange);
    }

    if (blogPostGlobeIcon && this.props.isMobile) {
      blogPostGlobeIcon.remove()
    }

    if (blogPostSearchBtn && this.props.isMobile) {
      blogPostSearchBtn.remove()
    }
  }

  handleInputChange(event) {
    const inputValue = event.target.value
    this.updateQuery(inputValue)
  }

  _resetSearch = () => {
    if (this.state.resetSearch) {
      this.setState({
        query: '',
        queryResults: []
      });
    } else {
      this.setState({ queryResults: [] });
    }
  }

  handleClickOutside = () => {
    this.setState({ queryResults: [] });
  }

  integrateDropDownElement = (results) => {
    // Find the parent element of the input
    const searchInputElement = document.getElementById(this.state.bikeSearchInputId)
    const spanDropDownElement = document.getElementById('blog-post-bike-dropdown')
    const dropDownWrapperElement = document.getElementById('dropdown-wrapper')     
    
    if (spanDropDownElement) {
      // remove dropDown element if already exist
      spanDropDownElement.remove()
    }

    if (dropDownWrapperElement) {
      dropDownWrapperElement.remove()
    }

    const parentElement = searchInputElement.parentElement;
    // Create a new span element
    const spanElement = document.createElement('span');
    
    // Set the HTML content for the span element
    renderDropDownResults(
      results, spanElement, this.props
    )
    
    parentElement.insertBefore(spanElement.firstChild, searchInputElement.nextSibling);

  }

  loadPost = async (post = null) => {
    let postUrl = post ? post : this.props.match.params.post
    try {
      const resp = await butter.post.retrieve(postUrl)
      this.setState({
        data: resp.data.data,
        loading: false,
      })

      if (resp.data) {
        trackPageView(resp.data.data.title, 'Blog')
      }
      fitvids()
      this.uploadSearchScript()

    } catch (error) {
      if (this.props.match.url == '/blog/posts/karson-h') {
        this.loadPost('motorcycle-rental-review-kh')
        this.props.history.push('motorcycle-rental-review-kh')
      } else if (
        this.props.match.url ==
        '/blog/posts/new-york-city-is-a-haven-for-urban-motorcyclists-but-its-not-for-the-faint-of-heart'
      ) {
        this.loadPost('new-york-motorcycle')
        this.props.history.push('new-york-motorcycle')
      } else if (blogPostEndpoints?.includes(this.props.match.url)) {
        this.loadPost('15-must-attend-moto-shows-this-year-everything-you-need-to-know')
        this.props.history.push('15-must-attend-moto-shows-this-year-everything-you-need-to-know')
      } else {
        this.loadPost('free-ride-how-can-you-and-all-of-your-friends-rent-motorcycles-for-free')
        this.props.history.push('free-ride-how-can-you-and-all-of-your-friends-rent-motorcycles-for-free')
      }
    }
  }

  getBlogAdvertisement = async () => {
    let apiURL = 'advertisement/for_blog'
    await apiProcess(apiURL, null, 'blog-advertisement', 'blog posts advertisement call from /blog')
      .then(res => {
        const { desktop_advertisement, mobile_advertisement } = res
        if (desktop_advertisement || mobile_advertisement) {
          this.setState({
            desktopAdvertisement: desktop_advertisement ? desktop_advertisement : null,
            mobileAdvertisement: mobile_advertisement ? mobile_advertisement : null
          })
        }
      })
      .catch(error => {
        this.setState({
          desktopAdvertisement: null,
          mobileAdvertisement: null
        })
        console.log("Failed to fetch blog posts advertisement")
      })
  }

  componentWillUnmount() {
    document.body.classList.remove('blog')
    const searchInputElement = document.getElementById(this.state.bikeSearchInputId)
    const dropdownElement = document.getElementById('mapbox-ac-suggestion-wrapper')

    if (dropdownElement) {
      searchInputElement.removeEventListener('onclick', handleSuggestionSelect)
    }

    if (searchInputElement) {
      searchInputElement.removeEventListener('input', this.handleInputChange)
    }
  }

  render() {
    const post = this.state.data
    const { loading, desktopAdvertisement, mobileAdvertisement } = this.state
    return (
      <React.Fragment>
        {!loading && (
          <>
            <MetaTags
              title={post.seo_title}
              description={post.meta_description}
              url={'/blog/posts/' + this.props.match.params.post}
              type={'Company'}
              image_id={post.featured_image}
              facebookDescription={post.meta_description}
              fetch={true}
            />
            {post.author && ( //i don't know why we use author here
              <Helmet>
                <script type="application/ld+json">
                  {JSON.stringify({
                    '@context': 'https://schema.org',
                    '@type': 'NewsArticle',
                    mainEntityOfPage: {
                      '@type': 'WebPage',
                      '@id':
                        'https://www.twistedroad.com/blog/posts/' +
                        this.props.match.params.post,
                    },
                    headline: post.title,
                    image: post.featured_image,
                    datePublished: post.published,
                    dateModified: post.published,
                    author: {
                      '@type': 'Person',
                      name:
                        post.author.first_name + ' ' + post.author.last_name,
                    },
                    publisher: {
                      '@type': 'Organization',
                      name: 'Twisted Road',
                      logo: {
                        '@type': 'ImageObject',
                        url:
                          'https://res.cloudinary.com/twisted-road/image/upload/c_fill,g_center,q_auto,f_auto/v1567103895/frontend_assets/seo/twisted-road-logo-black-seo.png',
                      },
                    },
                    description: post.meta_description,
                    articleBody: cleanArticleBody(post.body),
                  })}
                </script>
              </Helmet>
            )}
            <BlogMenu isMobile={this.props.isMobile} />
            <Container className={`${this.props.isMobile ? 'blog-adv-wrapper-mobile' : 'blog-adv-wrapper'}`}>
              <BlogAdvertisement
                isMobile={this.props.isMobile}
                desktopAdvertisement={desktopAdvertisement}
                mobileAdvertisement={mobileAdvertisement}
              />
              <main>
                <article itemscope itemtype="https://schema.org/Article">
                  <Container className="small">
                    {post.categories && (
                      <span className="is-uppercase has-text-primary has-text-weight-bold">
                        {post.categories[0].name}
                      </span>
                    )}
                    <header>
                      <h1 itemprop="headline" className="has-text-weight-bold title is-1">
                        {post.title}
                      </h1>
                      <meta itemprop="datePublished" content={`${moment(post.published).format("YYYY-MM-DD")}`}/>
                      <meta itemprop="dateModified" content={`${moment(post.updated || post.published).format("YYYY-MM-DD")}`} />
                    </header>
                    <Columns className="is-vcentered">
                      <Columns.Column size={8}>
                        <div className="is-flex is-align-content-center">
                          <div>
                            <img
                              src={userPhotoURL(
                                post.author.profile_image === ''
                                  ? null
                                  : post.author.profile_image
                              )}
                              alt={`${post.author.first_name} ${post.author.last_name}`}
                              className="is-avatar medium"
                            />
                          </div>
                          <div className="pt-2">
                            <span className="is-block has-text-black has-text-weight-bold">
                              {post.author.first_name} {post.author.last_name}
                            </span>
                            <span className="is-flex has-text-grey ">
                              <span>
                                {moment(post.published).format('MMMM D, YYYY')}{' '}
                              </span>
                              <span className="is-inline-block ml-2 mr-2">
                                &#xb7;
                              </span>
                              <Dropdown
                                onChange={(selected) =>
                                  this.props.history.push(
                                    `/blog/category/${selected}`
                                  )
                                }
                                hoverable={true}
                                className="is-inline-dropdown"
                              >
                                {post.categories.map((cat, i) => (
                                  <Dropdown.Item key={i} value={cat.slug}>
                                    {cat.name}
                                  </Dropdown.Item>
                                ))}
                              </Dropdown>
                            </span>
                          </div>
                        </div>
                      </Columns.Column>
                      <Columns.Column size={4} className="has-text-right">
                        <BlogSocialShare
                          title={post.title}
                          slug={this.props.match.params.post}
                        />
                      </Columns.Column>
                    </Columns>
                    <img
                      src={cl.url(post.featured_image, {
                        gravity: 'center',
                        height: 630,
                        width: 1200,
                        crop: 'fill',
                        format: 'jpg',
                        type: 'fetch',
                        quality: 80,
                        //overlay: new cloudinary.Layer().publicId("frontend_assets/seo/facebook-overlay")
                      })}
                      className={'mb-6 is-block'}
                      alt={post.title}
                    />
                    <section className="blog-content-wrap" itemProp="articleBody">
                      <div
                        className="content is-medium"
                        dangerouslySetInnerHTML={{ __html: post.body }}
                      />
                    </section>
                    <Columns className="is-centered">
                      <Columns.Column size={8}>
                        <AuthorBlock authorData={post.author} />
                      </Columns.Column>
                      {post.categories && (
                        <RelatedPosts
                          category={post.categories[0]}
                          className={'mt-6'}
                        />
                      )}
                    </Columns>
                  </Container>
                </article>
              </main>

              <BlogAdvertisement
                isMobile={this.props.isMobile}
                desktopAdvertisement={desktopAdvertisement}
                mobileAdvertisement={mobileAdvertisement}
              />
            </Container>
            <ListingRentCTA />
          </>
        )}
      </React.Fragment>
    )
  }
}
export default compose(withSizes(MAP_SIZES_TO_PROPS))(withRouter(SinglePost))

SinglePost.defaultProps = {
  country: 'us'
}

